import { Directive, inject, Input, TemplateRef } from '@angular/core';

export interface DataTableCellContext {
  $implicit: unknown;
  row: unknown;
  /** 0 for top-level rows, 1 for the child rows of a tree table. */
  level: number;
  /** The row a child row is listed under in a tree table, otherwise null. */
  parent: unknown;
}

/** Marks an `<ng-template>` as the custom cell renderer for a given column key. */
@Directive({
  selector: '[appDataTableCell]',
  standalone: true,
})
export class DataTableCellDirective {
  @Input('appDataTableCell') columnKey = '';

  readonly templateRef = inject(
    TemplateRef,
  ) as TemplateRef<DataTableCellContext>;
}
